import {
  Component,
  Input,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
  ViewChildren,
  QueryList
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { ElementoImagenSlideComponent } from '@appNeo/pages/components/elemento-imagen-slide/elemento-imagen-slide.component';
import {SliderComponent, TipoPaginadorSliderEnum} from '@appNeo/pages/plugins/slider/slider.component';
import { environment } from '@environments/environment';
import { IMGCAROUSEL, IMGSLIDER } from './inicio-configuracion';
import { DEMO_SECCION_INICIO_ZONA_FAN } from './seccion-edicion-data';

import { PAGINAS_ROUTES } from '@appNeo/pages/pages-routes-data';
import { ConfigTituloPaginasService } from '@appNeo/core/services/config-titulo-paginas.service';
import { ProximamenteDlgComponent } from '@appNeo/pages/components/proximamente-dlg/proximamente-dlg.component';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { ConstantesConfiguracionCalendarioEnum } from '@appNeo/core/helpers/enums/constantesConfiguracionCalendarioEnum';
import { finalize } from 'rxjs';

@Component({
  selector: 'neo-pagina-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss', './inicio-hero.scss', './inicio-carousel.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InicioComponent {
  @Input() pathZonaFan: string = '/' + PAGINAS_ROUTES.PAGINA_ZONAFAN;
  @Input() pathCumpleanos: string = '/' + PAGINAS_ROUTES.PAGINA_CUMPLEANOS;
  @Input() pathComuniones: string = PAGINAS_ROUTES.PAGINA_COMUNIONES;
  @Input() pathOtrosEventos: string = '/' + PAGINAS_ROUTES.PAGINA_OTROSEVENTOS;
  @ViewChildren(ProximamenteDlgComponent) accionesDialogoProximamente: QueryList<ProximamenteDlgComponent>;
  // @Input() pathReservar: string = '/' + PAGINAS_ROUTES.PAGINA_RESERVAR;
  @Input() pathReservar: string = '/' + PAGINAS_ROUTES.PAGINA_RESERVAR;
  @Input() constanteComprobarAccion = ConstantesConfiguracionCalendarioEnum.AccesoAltaReservasPublico;
  imagesCarousel = IMGCAROUSEL;


  // slides: any[] = [
  //   { src: 'https://loremflickr.com/1920/1080?random=1', alt: 'img1', titulo: 'Titulo', texto: 'Texto', link: 'http://localhost:5101/cumpleanos', boton: 'Ver más' },
  //   { src: 'https://loremflickr.com/1920/1080?random=2', alt: 'img2', titulo: 'Titulo', texto: 'Texto', link: 'http://localhost:5101/cumpleanos', boton: 'Ver más' }
  // ]
  modulos;
  // secciones editables
  secciones: [] = []; 
  
  zona_fan_tit = 'zona-fan-tit';
  zona_fan_img = 'zona-fan-img';
  zona_fan_sub = 'zona-fan-sub';
  zona_fan_txt = 'zona-fan-txt';

  espacios_tit = 'espacios-tit';
  espacios_img = 'espacios-img';

  celebraciones_tit = 'celebraciones-tit';
  celebraciones_img1 = 'celebraciones-img1';
  celebraciones_sub1 = 'celebraciones-sub1';
  celebraciones_txt1 = 'celebraciones-txt1';
  celebraciones_sub2 = 'celebraciones-sub2';
  celebraciones_txt2 = 'celebraciones-txt2';
  celebraciones_img2 = 'celebraciones-img2';
  celebraciones_img3 = 'celebraciones-img3';
  celebraciones_sub3 = 'celebraciones-sub3';
  celebraciones_txt3 = 'celebraciones-txt3';
  
  espacios = new Object();
  precargarSlider;
  precargaInicioMeta;
  constructor(
    private helpersService: HelpersService,
    private edicionSeccionesService: EdicionSeccionesService,
    private route: ActivatedRoute,
    private confTitulo: ConfigTituloPaginasService,
    private router: Router,
    private preferenciasService: PreferenciasService,
    private auxiliarService: AuxiliarService
  ) {
    this.route.data.subscribe(
      response => {
        this.precargarSlider = response.seccionEditables.inicio_hero;
        this.precargaInicioMeta = response.seccionEditables.inicio_meta;
      }
    );
  }

  get _TipoPaginadorSliderEnum() {
    return TipoPaginadorSliderEnum;
  }

  ngOnInit(): void {
    this.iniciarPagina();
  }

  iniciarPagina() {
    // **********************************
    // Titulo
    // **********************************
    this.confTitulo.establecerTitulo('Inicio', 'inicio-meta', this.precargaInicioMeta, 'meta-tit');
    this.confTitulo.establecerMeta(environment.descripcionMetaDefecto, 'inicio-meta', this.precargaInicioMeta, 'meta-des');
    // ***********************Titulo('Inicio', 'inicio-meta');
    // **********************************
    // SLIDER
    // **********************************
    let contenido_slides = [];
    let datosSlider = [];
    if (this.helpersService.hayModulo('edicion')) {
      // this.edicionSeccionesService.getContenidoBloquesSubseccion('inicio-hero').subscribe(data => {

      this.precargarSlider.elementos.forEach((elemento, index) => {
          let datosSlide = new Object();
          let portrait = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hero-img-portrait', index);
          let landscape = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hero-img-landscape', index);
          datosSlide['media'] = new Object();
          if (portrait) {
            datosSlide['media']['src'] = portrait.ruta;
            datosSlide['media']['(orientation: portrait)'] = portrait.ruta;
            datosSlide['media']['alt'] = portrait.nombre;
          }
          if (landscape) {
            datosSlide['media']['src'] = landscape.ruta;
            datosSlide['media']['(orientation: portrait)'] = landscape.ruta;
            datosSlide['media']['alt'] = landscape.nombre;
          }
          datosSlide['titulo'] = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hero-tit', index);

          datosSlide['texto'] = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hero-txt', index);
          datosSlide['boton'] = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hero-btn', index);
          datosSlide['enlace'] = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hero-lnk', index);
          contenido_slides[index] = datosSlide;
          // array_push($slides, $this -> load -> view('inicio/inicioSlide', $datosSlide, true));
        })
      // })
      this.edicionSeccionesService.getContenidoBloquesSubseccion('inicio-espacios').subscribe(data => {
        // console.log('DEGUG DATA SECCIONES INICIO', data);
        data.elementos.forEach((elemento, index) => {
          let indice = (data.multiple) ? index : -1;
          this.espacios['titulo'] = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'espacios-tit', indice);
          this.espacios['imagenes'] = this.mapearImagenesCarousel(this.edicionSeccionesService.getCamposEdicionItem(elemento, 'espacios-img', indice));
        });
      });
    } else {
      for (let i = 1; i <= 4; i++) {
        let datosSlide = [];
        datosSlide['media'] = [];
        datosSlide['media']['src'] = 'https://picsum.photos/id/237/500/400';
        datosSlide['media']['alt'] = 'inicio_hero-tit' + i;
        datosSlide['titulo'] = 'inicio_hero-tit' + i;
        datosSlide['texto'] = 'inicio_hero-txt' + i;
        datosSlide['boton'] = 'inicio_hero-btn' + i;
        datosSlide['enlace'] = '';
        contenido_slides.push(datosSlide);
        // array_push($slides, $this -> load -> view('inicio/inicioSlide', $datosSlide, true));
      }
    }
    datosSlider['id'] = 'hero-slider';
    datosSlider['slides'] = contenido_slides;
    datosSlider['handlers'] = true;
    datosSlider['pagination'] = 'fraction';
    this.secciones['inicio_hero'] = [];
    this.secciones['inicio_hero']['slider-hero'] = datosSlider;

    // **********************************
    // SECCION ZONA FAN
    // **********************************
    this.secciones['inicio_zonaFan'] = DEMO_SECCION_INICIO_ZONA_FAN;

    this.edicionSeccionesService.getContenidoBloquesSubseccion('inicio-celebraciones').subscribe(data => {
      data.elementos.forEach((elemento, index) => {
        let indice = (data.multiple) ? index : -1;
        this.celebraciones_tit = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'celebraciones-tit', indice);
        this.celebraciones_img1 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'celebraciones-img1', indice);
        this.celebraciones_sub1 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'celebraciones-sub1', indice);
        this.celebraciones_txt1 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'celebraciones-txt1', indice);
        this.celebraciones_sub2 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'celebraciones-sub2', indice);
        this.celebraciones_txt2 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'celebraciones-txt2', indice);
        this.celebraciones_img2 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'celebraciones-img2', indice);
        this.celebraciones_img3 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'celebraciones-img3', indice);
        this.celebraciones_sub3 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'celebraciones-sub3', indice);
        this.celebraciones_txt3 = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'celebraciones-txt3', indice);
        return;
      })
    })

    // **********************************
    // SECCION CARROUSEL ESPACIOS
    // **********************************
    this.edicionSeccionesService.getContenidoBloquesSubseccion('inicio-espacios').subscribe(data => {
      data.elementos.forEach((elemento, index) => {
        let indice = (data.multiple) ? index : -1;
        this.espacios_tit = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'espacios-tit', indice);
        this.espacios_img = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'espacios-img', indice);
        return;
      })
    })

    // **********************************
    // SECCION TIPOS EVENTOS
    // **********************************
    this.edicionSeccionesService.getContenidoBloquesSubseccion('inicio-zona-fan').subscribe(data => {
      data.elementos.forEach((elemento, index) => {
        let indice = (data.multiple) ? index : -1;
        this.zona_fan_tit = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'zona-fan-tit', indice);
        this.zona_fan_img = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'zona-fan-img', indice);
        this.zona_fan_sub = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'zona-fan-sub', indice);
        this.zona_fan_txt = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'zona-fan-txt', indice);
        return;
      })
    })

    console.log('Contenido slider hero ', this.secciones);
  }

  mapearImagenesCarousel(imagenes: any[]) {
    let imagenesMap = [];
    imagenes.forEach(imagen => {
      if (imagen['ruta'] && imagen.temporal != 1) {
        imagenesMap.push(
          {media: {src: imagen['ruta'], alt: imagen['alt'] } }
        )
      }
    })
    return imagenesMap;
  }

  accederReservar() {
    this.validarAccion();
  }

  desencadenarAccion: boolean = !environment.proximamente_reservas
  accion() {
    if (this.desencadenarAccion) {
      this.router.navigate([this.pathReservar]);
    } else {
      this.mostrarProximamente();
    }
  }
  validarAccion() {
    this.preferenciasService.getApi(this.constanteComprobarAccion, true)
      .pipe(
        finalize(() => {
          this.accion();
        })
      )
      .subscribe(
        x => this.desencadenarAccion = this.auxiliarService.getBoolean(x.valor),
        e => this.desencadenarAccion = this.auxiliarService.getBoolean(this.preferenciasService.get(this.constanteComprobarAccion))
      );
  }
  mostrarProximamente() {
    this.accionesDialogoProximamente.first.abrirDialogo();
  }
}
